import PropTypes from 'prop-types'
import { SIZE } from 'baseui/input'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useIbanVerifier from '@/containers/SubscriptionFormPageNew/Components/IbanVerifier/useIbanVerifier'
import {
  StyledContainer,
  StyledResult,
} from '@/containers/SubscriptionFormPageNew/Components/IbanVerifier/styled-components'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import IconCarbonFinance from '@/shared/icons/IconCarbonFinance'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import {
  ModuleBody,
  ModuleContent,
} from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'

const IbanVerifier = ({ hidden }) => {
  const { t, iban, setIban, canVerify, verifyIban, ibanIsLoading, bic, error } = useIbanVerifier()
  const { expanded, toggle } = useModuleCollapse('iban-verifier')

  if (hidden) {
    return null
  }

  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconCarbonFinance} moduleKey='iban-verifier'>
          {t('subscriptionTools:iban_verifier.module_title')}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='iban-verifier' />
      </ModuleHeader>
      <ModuleContent hidden={!expanded}>
        <ModuleBody $gap='0.5rem'>
          <SDFormControl label={t('subscriptionTools:iban_verifier.iban')} error={error}>
            <SDInput
              id='iban-verifier-input'
              placeholder={t('subscriptionTools:iban_verifier.placeholder')}
              currentValue={iban}
              outerOnchange={setIban}
              error={!!error}
              autoComplete='off'
            />
          </SDFormControl>
          <SDButton
            block
            id='iban-verifier-button'
            size={SIZE.compact}
            isLoading={ibanIsLoading}
            disabled={!canVerify}
            onClick={verifyIban}
          >
            {t('subscriptionTools:iban_verifier.search_button')}
          </SDButton>
          <StyledResult id='iban-verifier-bic'>
            {t('subscriptionTools:iban_verifier.bic_result')} {bic || '—'}
          </StyledResult>
        </ModuleBody>
      </ModuleContent>
    </StyledContainer>
  )
}

IbanVerifier.propTypes = {
  hidden: PropTypes.bool,
}

export default IbanVerifier
